import { generateMedia } from "styled-media-query";

const ScreenSizes = generateMedia({
  mobile: "767px",
  tablet: "991px",
  desktop: "1199px",
});

export default ScreenSizes;
